import React from "react";
import styles from './ListSymbols.module.css';
import ApiService from '../../services/AppService';


export class ListSymbolItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.element = React.createRef();
    }

    getGraph = () => this.props.graph;

    setupDraggableArea = () => {
        this.dragSource = window.mxUtils.makeDraggable(this.element.current, this.getGraph, (graph, evt, cell, x, y) => {
            const {symbol, setSchematicElement, schematicList} = this.props;
            ApiService.place_symbol(graph, evt, cell, x, y, symbol, setSchematicElement, schematicList, this.element.current);
        }, null, 0, 0);

    }

    componentDidMount() {
        const {graph} = this.props;
        if (graph) {
            this.setupDraggableArea();
        }
    }

    componentWillUnmount() {
        if (this.dragSource) {
            this.dragSource.removeListeners();
        }
    }

    render() {
        const {symbol, active, handleClick} = this.props;
        const classes = active ? `${styles.symbol_row} ${styles.active}` : styles.symbol_row;
        return (
            <div ref={this.element} className={`${classes} ${styles.none_selection}`}
                 onClick={() => handleClick(symbol)}>
                <span className={styles.symbol_row_name}>{symbol.name}</span>
                <span className={styles.symbol_row_description}>{symbol.desc}</span>
            </div>
        )
    }
}